<template>
  <div class="login">
    <div class="login-box">
      <div class="container">
        <p class="title">用户登录</p>
        <p class="en_title">USER LOGIN</p>
        <el-input
          placeholder="账号"
          @keyup.enter.native="login"
          v-model="account"
        >
          <i slot="prefix" class="iconfont icon-xinxi"> </i>
        </el-input>
        <el-input
          placeholder="密码"
          @keyup.enter.native="login"
          type="password"
          v-model="password"
        >
          <i slot="prefix" class="iconfont icon-mima"></i>
        </el-input>
        <el-button
          :loading="loading"
          type="primary"
          class="login_btn"
          @click="login"
          >登录</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
// import { login, getShopDetail } from '@/models/commonModel'
// import {jzbReqAcc} from '@/models/jzbModel'
import { loadSettleType } from "@/models/commonModel";
export default {
  data() {
    return {
      account: "",
      password: "",
      loading: false
    };
  },
  methods: {
    async login() {
      this.loading = true;
      let params = {
        account: this.account,
        password: this.password
      };
      await this.$store
        .dispatch("user/login", params)
        .then(async res => {
          console.log(res, "res3333333");
          // localStorage.setItem('isShowDialogOnline', '1');// 是否显示数据看板上线公告
          const path = localStorage.getItem("menuActive");
          console.log(path, "path");
          if (path) {
            this.$router.push(path);
          } else {
            if (localStorage.getItem("is_jgj") === "1") {
              // 为紧固件
              this.$router.push("/order/manageFastener");
            } else {
              console.log(999999);
              this.$router.push("/dataReport/echart");
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          // this.password = ''
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  position: absolute;
  background-image: url("../assets/img/banner.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 1200px;
  height: 100%;
  .login-box {
    position: absolute;
    right: 100px;
    top: 200px;
    width: 600px;
    height: 315px;
    background-image: url("../assets/img/login.png");
    background-size: cover;
    background-repeat: no-repeat;
    .container {
      position: relative;
      left: 300px;
      width: 290px;
      .title {
        color: #ff6325;
        font-size: 22px;
        font-weight: 400;
      }
      .en_title {
        font-size: 12px;
        margin-top: -16px;
        margin-bottom: 6px;
        color: #bdbdbd;
      }
      .el-input {
        width: 255px;
        margin-top: 20px;
      }
      .login_btn {
        width: 255px;
        margin-top: 20px;
      }
      .iconfont {
        margin-left: 4px;
        line-height: 40px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue